import { render, staticRenderFns } from "./svg-container.vue?vue&type=template&id=c57d0fca"
import script from "./svg-container.vue?vue&type=script&lang=js"
export * from "./svg-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports